<template>
    <section class="terms-page">
        <h1>Pravila i uslovi</h1>

        <form @submit.prevent="submitAccept" class="terms-form">
           
            

           <p> Dragi TRONCI,<br><br>

u daljem tekstu Vam dostavljamo pravilnik o članarinama, te Vas molimo da pažljivo pročitate.<br><br>


Članarina se plaća na prvom treningu i važi (traje) 30 dana.<br><br>

Po isteku članarine ili utrošenih termina potrebno je uplatiti novu članarinu na prvom sledećem treningu od kada počinje da se računa nova članarina odnosno novi termini.<br>
Ukoliko osoba ne dođe na prvi sledeći trening po isteku prethodne članarine, i/ili ne plati treninge za predstojeći mesec, mesto u datoj grupi se oslobađa i nudi prvoj osobi sa liste čekanja.<br>
Klijent-vežbač može otkazati svoj trening najkasnije 6č pre treninga na koji treba da dođe i taj trening se neće računati, odnosno vežbaču se neće zabeležiti da je bio na tom treningu. Trening koji se otkaže, osoba može iskortistiti u toku svoje članarine (30dana) dolazeći u bilo koju grupu u kojoj se pokaže slobodno mesto i ukoliko se prijavi putem aplikacije i "upadne" u tu grupu.<br><br>
Klijent se može ubaciti u drugu grupu najkasnije 1č do početka treninga.
Članovi plaćaju cenu koja je aktuelna u datom trenutku i ona važi sve dok se ne napravi pauza od mesec dana sa treniranjem i/ili plaćanjem. Po povratku na treninge, ukoliko je prošlo mesec dana pauze, osoba plaća treninge po ceni koja je aktuelna za dati period.<br>
Osoba može rezervisati sebi mesto u grupi plaćanjem članarinei ako nije tu, tj ako je sprečena da trenira. U suprotnom, TC TRON ne garantuje da će vežbač nakon povratka sa pauze imati mesto u grupi kao i da će članarina biti ista.<br>
Član može platiti dve ili više članarine odjednom koje će se povezati, ukoliko tako želi.<br><br>

Za sve nejasnoće pišite na broj 0611623967.<br><br>

Vaš Trening Centar Tron</p>

            <div class="actions">
                <button
                    type="submit"
                    class="btn accept"
                >
                    {{ loading && action === 'accept' ? 'Sačekajte...' : 'Prihvati pravila' }}
                </button>
            </div>

            
        </form>
    </section>
</template>

<script>
import PortalLayout from '@/js/Layouts/PortalLayout'

export default {
  layout: PortalLayout,
  data() {
    return {
      accepted: false,
      loading: false,
      message: '',
      success: false,
      action: '', // 'accept' | 'logout'
      // Podesite ove rute prema vašem backendu
      acceptEndpoint: '/portal/accept-terms', // POST { accepted: true }
    }
  },
  methods: {
    // Utility: uzmi CSRF token iz meta taga (ako ga koristite)
    getCsrfToken() {
      const el = document.querySelector('meta[name="csrf-token"]')
      return el ? el.getAttribute('content') : ''
    },

    
    async postJson(url, data) {
      const headers = {
        'Content-Type': 'application/json'
      }
      const csrf = this.getCsrfToken()
      if (csrf) headers['X-CSRF-TOKEN'] = csrf

      const res = await fetch(url, {
        method: 'POST',
        headers,
        body: JSON.stringify(data),
        credentials: 'same-origin'
      })
      const text = await res.text()
      let json = null
      try { json = JSON.parse(text) } catch (e) { json = null }
      if (!res.ok) throw { status: res.status, body: json ?? text }
      return json ?? {}
    },

    async submitAccept() {
      
      
      this.$inertia.post('/portal/accept-terms', {},
                {
                    preserveState: true,
                    preserveScroll: true,
                  
                });
    },

  }
}
</script>

<style scoped>
.terms-page {
    max-width: 640px;
    margin: 24px auto;
    padding: 16px;
    font-family: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial;
}

.terms-form {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.terms-text {
    color: #333;
}

.checkbox {
    display: flex;
    align-items: center;
    gap: 8px;
    user-select: none;
}

.actions {
    display: flex;
    gap: 8px;
}

.btn {
    padding: 8px 12px;
    border: 1px solid #bbb;
    background: #fff;
    cursor: pointer;
    border-radius: 4px;
}

.btn:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

.btn.accept {
    background: #1e90ff;
    color: #fff;
    border-color: #1e90ff;
}

.btn.logout {
    background: #ef4444;
    color: #fff;
    border-color: #ef4444;
}

.msg-success {
    color: #065f46;
}

.msg-error {
    color: #7f1d1d;
}
</style>